module.exports = __webpack_public_path__ + "img/refrigerator.29c1f222.svg";